/**
 * Opens sharing links in a popup window
 * @module embed/sharing_link
 */

import { delegate } from '@/lib/events';

const SELECTOR = '.js-sharing-link';

/**
 * @param {HTMLElement} scope The element on which to listen on clicks
 */
export default function setupSharingLinks(scope) {
  scope.addEventListener(
    'click',
    delegate(SELECTOR, (event, target) => {
      if (!target.href.indexOf('mailto') == 0) {
        event.preventDefault();
        openPopup(target.href);
      }
    })
  );
}

function openPopup(url, width = 600, height = 400) {
  var left = screen.width / 2 - width / 2,
    top = screen.height / 2 - height / 2;

  window.open(
    url,
    '',
    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' +
      width +
      ',height=' +
      height +
      ',top=' +
      top +
      ',left=' +
      left
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/sharing_link.js